<template>
  <div>
    <kendo-datasource ref="datasource"
                      :transport-read="read"
                      :autobind="true"
                      :schema-model-fields="schemaModelFields"
                      :batch="true"
                      :page-size="10"></kendo-datasource>
    <kendo-toolbar>
      <b-navbar class="p-0">
        <b-navbar-nav class="align-items-lg-center mr-auto">
          <b-btn-toolbar key-nav>
            <b-btn-group class="mr-2" v-show="addOption">
              <b-btn variant="outline-primary icon-btn" @click="editar" v-b-modal.modal-scoped>
                <span class="fas fa-plus"></span>
              </b-btn>
            </b-btn-group>
            <b-btn-group class="mr-2">
              <!--botão editar-->
              <b-btn v-if="editOption"
                     variant="outline-secondary icon-btn"
                     @click="editar(current)"
                     :disabled="!current">
                <span class="fas fa-pencil-alt"></span>
              </b-btn>
              <!--botão deletar-->
              <b-btn v-if="deleteOption"
                     variant="outline-secondary icon-btn"
                     @click="deletar"
                     :disabled="!current">
                <span class="fas fa-trash"></span>
              </b-btn>
            </b-btn-group>

            <!--botão exportar-->
            <b-btn-group v-if="exportOption">
              <b-btn variant="outline-secondary icon-btn" @click="exportExcel">
                <span class="fas fa-file-excel"></span>
              </b-btn>
            </b-btn-group>
          </b-btn-toolbar>
        </b-navbar-nav>
      </b-navbar>

      <!-- slot para botões extras na toolbar do grid -->
      <slot name="extraBtns"></slot>
      <b-navbar class="p-0 custom-navbar-right">
        <b-navbar-nav>
          <b-nav-form v-on:submit.prevent="">
            <b-input-group v-show="!filterOptionDisabled">
              <b-input-group-text slot="append">
                <span class="fas fa-search" v-on:click="refresh"></span>
              </b-input-group-text>
              <b-input v-model="searchParams" placeholder="Filtrar" type="text" />
            </b-input-group>
          </b-nav-form>
        </b-navbar-nav>
      </b-navbar>
    </kendo-toolbar>
    <kendo-grid ref="grid"
                :data-source-ref="'datasource'"
                :navigatable="true"
                :pageable="true"
                :selectable="true"
                :scrollable="true"
                :sortable="true"
                :resizable="true"
                @change="onRowClick">
      <slot name="gridColumns"></slot>
    </kendo-grid>
  </div>
</template>

<script>
import { saveExcel } from '@progress/kendo-vue-excel-export'
import VueLodash from 'vue-lodash'

export default {
  data () {
    return {
      current: null,
      searchParams: ''
    }
  },
  watch: {
    searchParams: function (newValue, oldValue) {
      if (newValue != oldValue) this.debouncedRefresh()
    }
  },
  created () {
    this.debouncedRefresh = _.debounce(this.refresh, 500)
  },
  mounted () {
    // Método de inicialização
    var vm = this
    var grid = this.$refs.grid.kendoWidget()
    var gridElement = grid.element
    var toolbarElement = gridElement.find('.k-grid-toolbar')
    toolbarElement.on('click', '.k-pager-refresh', function (e) {
      e.preventDefault()
      vm.refresh()
    })
  },
  methods: {
    rowCount: function () {
      return this.$refs.grid.kendoWidget('dataSource').dataSource._data.length
    },
    onCreate: function (options) {
      var that = this
      var request = { type: 'create', data: [options.data] }
      that.send(that.ws, request, options.success)
    },
    read: function (options) {
      this.onRead(options, this.searchParams)
    },
    onRowClick: function (event) {
      let grid = event.sender
      this.current = grid.dataItem(grid.select())
    },
    refresh: function (e) {
      this.current = null
      this.$refs.grid.kendoWidget('dataSource').dataSource.read()
      // this.$refs.grid.kendoWidget('dataSource').dataSource.totalPages()
      // this.$refs.grid.kendoWidget('dataSource').dataSource.page()
      this.$refs.grid.kendoWidget('dataSource').dataSource.page(1)
    },
    getGrid: function () {
      return this.$refs.grid.kendoWidget()
    },
    onDestroy: function (options) {
      var that = this
      var request = { type: 'destroy', data: [options.data] }

      that.send(that.ws, request, options.success)
    },
    editar: function (current) {
      if (current.uid) {
        let senderCurrent = Object.assign({}, current)
        if (this.modalEditReference) { this.modalEditReference.openModal(senderCurrent) } else { this.$parent.$refs['editar'].openModal(senderCurrent) }
      } else {
        if (this.modalEditReference) { this.modalEditReference.openModal() } else { this.$parent.$refs['editar'].openModal() }
      }
    },
      deletar: function () {
          let th = this
          if (this.current) {
              this.$api.UI.Confirmacao(this.deleteConfirmMsg, function () {
                  th.deleteFunction(th.current)
                  th.current = null
              })
          }
    },
    exportExcel () {
      let th = this
      let ds = th.$refs.grid.kendoWidget('dataSource').dataSource._data

      if (ds.length) {
        let columns = th.$refs.grid.kendoWidget('gridColumns').columns

        saveExcel({
          data: ds,
          fileName: this.exportFileName,
          columns: columns
        })
      }
    },
    getColumnvalues (column) {
      let ds = this.$refs.grid.kendoWidget('dataSource').dataSource._data
      if (ds.length) {
        let columnArray = []
        ds.forEach(el => {
          let value = el[column]

          if (value) { columnArray.push(value) }
        })

        return columnArray
      }
    }
  },
  props: {
    addOption: Boolean,
    editOption: Boolean,
    deleteOption: Boolean,
    exportOption: Boolean,
    filterOptionDisabled: Boolean,
    onRead: Function,
    deleteFunction: Function,
    deleteConfirmMsg: String,
    schemaModelFields: Object,
    exportFileName: String,
    modalEditReference: Object
  }
}
</script>
